module.exports = __webpack_public_path__ + "img/maciejc.fa71c631.png";